import { PRODUCT_LINK_ACTION_TYPE } from "./product-link.action";

export const PRODUCT_LINK_DOCUMENT_NAME = "desktopproductlink";

export const PRODUCT_LINK_CONTEXT = {
	get: PRODUCT_LINK_ACTION_TYPE.get,
};
